namespace Solovis.InvDataSelectors {

    export interface TagSelectorControlOptions extends Solovis.UI.BaseControlOptions {

        portalServices?: Solovis.Portal.IPortalServices;
        parameterSet?: any;

        selectionCallback?: any;
        cancelCallback?: any;

        tagSetId?: number;

        allowNullTag?: boolean;

        initialValue?: { tagSetId?: number, tagId?: number };

        /**
         * If fixedModelEnvironment is supplied, TagSelectorControl will just use this set of tag sets instead of trying
         * to retrieve the tag sets from the server.
         */
        fixedModelEnvironment?: any;

        defaultTagSet?: any;
    }


    export class TagSelectorControl extends Solovis.UI.BaseControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        private defaultTagSet: any;
        private parameterSet: any;

        private selectionCallback;
        private cancelCallback;
        private tagSetId;
        private _allowNullTag;
        private currentTag;
        private _showChangeTagSetForm;

        private _fixedModelEnvironment: any;

        private jsonModelEnv;
        private modelEnv: any;

        private _formDiv;
        private _formBuilder: Solovis.UI.InputControls.FormBuilder;

        private _initialWidth;
        private _availableHeight;

        private _tagsStringFilterListControl;


        constructor(options: TagSelectorControlOptions) {
            super(options);

            if (options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            if(options.parameterSet)
            {
                this.parameterSet = options.parameterSet;
            }

            this.defaultTagSet = options.defaultTagSet ? true : false;

            // selectionCallback should be a function that takes an item.
            this.selectionCallback = options.selectionCallback ? options.selectionCallback : null;
            this.cancelCallback = options.cancelCallback ? options.cancelCallback : null;

            this.tagSetId = options.tagSetId ? options.tagSetId : null;
            this._allowNullTag = options.allowNullTag ? true : false;
            this.currentTag = options.initialValue ? options.initialValue : null;

            this._fixedModelEnvironment = options.fixedModelEnvironment;

            this._showChangeTagSetForm = this.tagSetId == null;

            if (this.currentTag) {
                this.tagSetId = this.currentTag.tagSetId;
            }
        }


        public async doInitAsync(): Promise<void> {
            if (this.tagSetId) {

                if (this._fixedModelEnvironment) {
                    this.modelEnv = this._fixedModelEnvironment;
                }
                else {
                    let response = await this._portalServices.rpc().invoke("~/Selectors/TagSelector/GetTagsForTagSet", { tagSetId: this.tagSetId });

                    this.jsonModelEnv = response.result.modelEnvironment;
                    this.modelEnv = new (InvData as any).ModelEnvironment();
                    this.modelEnv.mergeEnvironmentData(this.jsonModelEnv);
                }
            }            
        }

        public _createTagSortString(tag, partialSortString) {
            var self = this;

            var labelLower = tag.label.toLowerCase();

            partialSortString = labelLower + "_Level" + tag.level + ":" + tag.id + "_Level" + tag.level + partialSortString;

            if (!tag.parentTagId) {

                return partialSortString;
            }
            else {
                partialSortString = "~~~" + partialSortString;
                var parentTag = tag.tagSet.tryGetTagById(tag.parentTagId);
                if (parentTag) {
                    return this._createTagSortString(parentTag, partialSortString);
                }
                else {
                    console.log("Unexpected: could not find parentTag");
                    return partialSortString;
                }
            }
        }

        public doRender() {
            var self = this;            

            var initialTagSet = null;

            if (this.modelEnv) {
                initialTagSet = this.modelEnv.tagSets.tryGetById(this.tagSetId);
            }

            // #region Tag Set Selection Form

            if (this._showChangeTagSetForm) {

                this._formDiv = $("<div>").appendTo(this.container);
                this._formBuilder = new Solovis.UI.InputControls.FormBuilder({
                    container: this._formDiv,
                    labelColumnWidth: 60,
                    width: this._initialWidth,
                    portalServices: this._portalServices
                });

                this._formBuilder.addEntry({
                    name: "tagSet",
                    label: "Tag Set",

                    initialValue: initialTagSet,
                    isVisible: () => !this.defaultTagSet,
                    editor: {
                        type: "parameter",
                        parameterOptions: {
                            parameterType: "tagSet"
                        }
                    }
                });

                $(this._formBuilder).bind("valueChanged", function () {
                    self._tagSetChangedHandler();
                });

                this._formBuilder.setupDone();
            }

            // #endregion

            this._renderStringFilterListControl();

            if (this._availableHeight) {
                this.setAvailableHeight(this._availableHeight);
                this._availableHeight = null;
            }
        }

        public setWidth(newWidth) {
            if (this._formBuilder) {
                this._formBuilder.setWidth(newWidth);
            }
            else {
                this._initialWidth = newWidth;
            }
        }

        public setAvailableHeight(overallHeight) {
            var self = this;

            if (overallHeight) {
                if (this._tagsStringFilterListControl && this._tagsStringFilterListControl.state >= Solovis.UI.BaseControl.ControlState.afterRender) {

                    var tagSetFormHeight = 0;

                    if (this._formDiv) {
                        tagSetFormHeight = this._formDiv.outerHeight();
                    }

                    this._tagsStringFilterListControl.setAvailableHeight(overallHeight - tagSetFormHeight);
                }
                else {
                    // The control is still rendering, so save the height and for use once the control is rendered
                    this._availableHeight = overallHeight;
                }
            }
        }

        public async _tagSetChangedHandler(): Promise<void> {
            let tagSet = this._formBuilder.getValueByName("tagSet");

            if (tagSet) {
                this.tagSetId = tagSet.tagSetId;

                if (this._fixedModelEnvironment) {
                    this.modelEnv = this._fixedModelEnvironment;
                }
                else {
                    let response = await this._portalServices.rpc().invoke("~/Selectors/TagSelector/GetTagsForTagSet", { tagSetId: this.tagSetId });

                    this.jsonModelEnv = response.result.modelEnvironment;
                    this.modelEnv = new (InvData as any).ModelEnvironment();
                    this.modelEnv.mergeEnvironmentData(this.jsonModelEnv);                    
                }

                this._renderStringFilterListControl();
            }
            else {
                this.tagSetId = null;
            }
        }

        public _renderStringFilterListControl() {
            var self = this;

            var tagSet = {
                tags: {
                    itemList: []
                }
            };

            var tagItemDivGenerator = function (itemHolder, filterOptions) {
                var itemDiv = $("<div>")
                    .css("padding-left", itemHolder.item.level * 10 + 10 + "px")
                    .text(itemHolder.item.label);

                var isSelectedItem = false;
                var selectedItem = self.currentTag ? { id: self.currentTag.tagId, label: self.currentTag.tagLabel } : null;
                if (selectedItem) {
                    isSelectedItem = true;
                    for (var property in selectedItem) {
                        if (selectedItem.hasOwnProperty(property)) {
                            if (selectedItem[property] !== itemHolder.item[property]) {
                                isSelectedItem = false;
                            }
                        }
                    }
                }

                if (isSelectedItem) {
                    itemDiv.addClass("active");
                }

                return itemDiv;
            };

            var tagFilter = function (itemList, filterOptions) {
                var resultList = [];

                var queryTextLower = filterOptions.queryText.toLowerCase();

                $(itemList).each(function (index, item: any) {
                    if (!_.isUndefined(item.label)) {
                        var labelLower = item.label.toLowerCase();
                        var match = labelLower.indexOf(queryTextLower);
                        if (match !== -1) {
                            resultList.push({
                                item: item,
                                labelLower: labelLower
                            });
                        }
                    }
                });

                function compare(a, b) {
                    if (a.item.sortLabel < b.item.sortLabel) {
                        return -1;
                    }
                    if (a.item.sortLabel > b.item.sortLabel) {
                        return 1;
                    }
                    return 0;
                }

                return resultList.sort(compare);
            }

            if (this.modelEnv) {
                var modelTagSet = this.modelEnv.tagSets.tryGetById(this.tagSetId);
                if (modelTagSet) {
                    if (this._allowNullTag) {
                        tagSet.tags.itemList.push({
                            isNullTagOption: true,
                            label: "(None)",
                            sortLabel: "(none)",
                            tagSet: { label: modelTagSet.label, id: modelTagSet.id }
                        });
                    }

                    $(modelTagSet.tags.itemList).each(function (index, tag: any) {
                        tag.sortLabel = self._createTagSortString(tag, "");
                        tagSet.tags.itemList.push(tag);
                    });
                }
            }

            if (!this._tagsStringFilterListControl) {
                var stringFilterListControlHostDiv = $("<div>")
                    .appendTo(this.container);

                this._tagsStringFilterListControl = new Solovis.UI.StringFilterListControl({
                    controlHost: stringFilterListControlHostDiv,
                    listItems: tagSet.tags.itemList,
                    itemDivGenerator: tagItemDivGenerator,
                    listFilter: tagFilter,
                    selectedItem: self.currentTag ? { id: self.currentTag.tagId, label: self.currentTag.tagLabel } : null
                });

                $(this._tagsStringFilterListControl)
                    .on("selectionChanged", function (e, data) {
                        var tag;

                        if (!data.item.isNullTagOption) {
                            tag = {
                                tagId: data.item.id,
                                tagLabel: data.item.label,
                                tagSetLabel: data.item.tagSet.label,
                                tagSetId: data.item.tagSet.id
                            };
                        }
                        else {
                            tag = {
                                tagSetLabel: data.item.tagSet.label,
                                tagSetId: data.item.tagSet.id
                            };
                        }

                        if (self.selectionCallback) {
                            self.selectionCallback(tag);
                        }
                    })
                    .on("renderComplete", function () {
                        if (self._availableHeight) {
                            self.setAvailableHeight(self._availableHeight);
                            self._availableHeight = null;
                        }
                        if (self.currentTag) {
                            self._tagsStringFilterListControl.scrollToSelectedItem();
                        }

                        self._tagsStringFilterListControl.focusFilter();
                    })
                    .on("escapeKey", function () {
                        if (self.cancelCallback) {
                            self.cancelCallback();
                        }
                    });

                this._tagsStringFilterListControl.setAsCurrentControl();
            }
            else {
                this._tagsStringFilterListControl.setListItems(tagSet.tags.itemList);
            }
        };
    }

}